var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-visual" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("img", {
        staticClass: "img-score",
        attrs: { src: "static/img/icon_score.png" }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [
        _vm._v("고객이 원하는 시간과 장소로"),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("방문하는 "),
        _c("span", [_vm._v("차량관리 서비스")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-content" }, [
        _vm._v("\n      엔진오일, 배터리 교체 시 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("13종 프리미엄 안전점검 무상 서비스까지"),
        _c("br"),
        _vm._v("\n      국산차, 수입차 21개 브랜드 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("1,308개 모델 서비스 가능!"),
        _c("br"),
        _vm._v("\n      이젠 정비소 가지 말고 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("집, 사무실에서 정비 받으세요.\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-download" }, [
        _c("img", {
          staticClass: "google",
          attrs: { src: _vm.googleImg },
          on: {
            click: function($event) {
              return _vm.googleDown()
            }
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "apple",
          attrs: { src: _vm.appImg },
          on: {
            click: function($event) {
              return _vm.appleDown()
            }
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("div", { staticClass: "website-save" }, [_vm._m(0)])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("a", { attrs: { href: "//carsuri.co.kr/", target: "_blank" } }, [
        _vm._v("카수리 홈페이지")
      ]),
      _vm._v("에서 누적 43만 건의 정비사례를 만나보세요.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a34b6aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a34b6aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/MainVisual.vue
// module id = null
// module chunks = 